/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Formulas_BeforeInputs */

const en_gc_guides_formulas_before = /** @type {(inputs: Gc_Guides_Formulas_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with a blank worksheet or a fresh practice copy. The steps below use English function names and comma-separated arguments. A cell reference such as A2 points to column A, row 2; A2:A4 includes all three cells from row 2 through row 4. Enter plain numbers in those cells so that you can calculate the answer by hand. Formula results are only as useful as the source values and ranges you choose.`)
};

const zh_gc_guides_formulas_before = /** @type {(inputs: Gc_Guides_Formulas_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从空白工作表或新的练习副本开始。下方使用英文函数名与逗号分隔参数。A2 指 A 列第 2 行；A2:A4 包含第 2 至第 4 行三个单元格。输入普通数字，方便手工核对。结果是否有用，取决于来源数据和引用范围是否正确。`)
};

/**
* | output |
* | --- |
* | "Start with a blank worksheet or a fresh practice copy. The steps below use English function names and comma-separated arguments. A cell reference such as A2 ..." |
*
* @param {Gc_Guides_Formulas_BeforeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_formulas_before = /** @type {((inputs?: Gc_Guides_Formulas_BeforeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Formulas_BeforeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_formulas_before(inputs)
	return zh_gc_guides_formulas_before(inputs)
});
export { gc_guides_formulas_before as "gc.guides.formulas.before" }